import { useRouter } from 'next/router';
import { useEffect, useContext } from 'react';
import { BookingContext } from '../../../shared/contexts/Booking.context';

export default function Home() {
  const router = useRouter();
  const { actions } = useContext(BookingContext);

  if (!router.isReady) return null;

  useEffect(() => {
    sessionStorage.clear();
    actions.clear();
    router.push(
      '/hotel/[hotelId]/bookingSearchForm',
      `/hotel/${router.query.hotelId}/bookingSearchForm`
    );
  }, [router.isReady, router.query.hotelId]);
  return null;
}
